import React, { ReactElement } from 'react';

import SheetContainer, { Content, Overlay, Sheet } from '../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../mobile/structural/sheet/hooks/useSheet';
import CellTypePopup from '../../../../../element/table/cellTypes/CellTypePopup';
import { CellTypeNames } from '../../../../../../common/table/CellTypeConstants';
import { CellTypeObjectWithAuto } from '../../../../../../common/table/TableTypes';

import './MobileCellTypeSheet.scss';

type Props = {
    sheetProps: UseSheetReturnType;
    locale: string;
    activeCellType: CellTypeNames | undefined;
    sharedCellTypeFormatOptions: CellTypeObjectWithAuto | undefined;
    lastClickedType: CellTypeNames | null;
    setLastClickedType: (type: CellTypeNames) => void;
};

const MobileCellTypeSheet = (props: Props): ReactElement => {
    const { sheetProps, ...cellTypePopupProps } = props;

    return (
        <SheetContainer className="MobileCellTypeSheet" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <div className="CellTypePopup">
                        <CellTypePopup {...cellTypePopupProps} closePopup={null} showInlineFormattingOptions={false} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileCellTypeSheet;
